import React from 'react';
import Project from '../Project'


function Portfolio() {
    return(
        <div id='portfolio'>
            <Project></Project>
        </div>
        
        
    )
}

export default Portfolio;